import type { AxiosInstance } from 'axios';

let polApiClient: AxiosInstance | null = null;

/**
 * Wire the host app's authenticated axios instance (e.g. apiService.client) before any PoL API calls.
 * The shell imports `./services/polService` which calls this on load.
 */
export function configurePolApiClient(client: AxiosInstance): void {
  polApiClient = client;
}

export function getPolApiClient(): AxiosInstance {
  if (!polApiClient) {
    throw new Error(
      '@signals/pol-ui: configurePolApiClient() was not called. The app shell must import ./services/polService before rendering PoL routes.'
    );
  }
  return polApiClient;
}
